import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
// Third party packages
import { MatDialog, MatDialogRef } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { finalize, tap } from "rxjs/operators";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { SuppliersService } from 'src/app/modules/suppliers/suppliers.service';
import { PrintQrDialogComponent } from 'src/app/shared/components/dialogs/print-qr-dialog/print-qr-dialog.component';
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { DocumentArchivesService } from "../../document-archives.service";
import DocumentTypeStructure from '../../documentTypes';
import { applyDocumentSearch } from "../../insert-dialog-doc-search.utils";
/**
 * Script start
 */
var PropertyDetailDocumentInsertDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PropertyDetailDocumentInsertDialogComponent(dialogRef, data, dialog, configService, translateService, authService, cookieService, toastrService, helperService, documentArchivesService, suppliersService, apiService, // DO NOT MOVE since it's used for 'autocomplete' field type
    settingsService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.dialog = dialog;
        this.configService = configService;
        this.translateService = translateService;
        this.authService = authService;
        this.cookieService = cookieService;
        this.toastrService = toastrService;
        this.helperService = helperService;
        this.documentArchivesService = documentArchivesService;
        this.suppliersService = suppliersService;
        this.apiService = apiService;
        this.settingsService = settingsService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.dialogIsLoading = false; // Used to view/hide form loading spinner
        // BEGIN - Edit item form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true
            }
        };
        this.printModuleBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.printModule"),
            spinnerSize: 19,
            raised: false,
            stroked: false,
            flat: true,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-print",
                inline: true
            }
        };
        this.printQrBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.printLabel"),
            spinnerSize: 19,
            raised: false,
            stroked: false,
            flat: true,
            fab: false,
            buttonColor: "accent",
            spinnerColor: "accent",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-qrcode",
                inline: true
            }
        };
        // END - Edit item form
        this.existingNotes = [];
        this.qrcodeData = JSON.stringify({
            code: "005073005071S000125C"
        });
        this.selectedDocs = [];
        this.displayedStructures = [];
        this.displayedStructuresContract = [];
        this.selectedStructures = [];
        this.selectedStructureFree = "";
        this.documentTypeStructure = new DocumentTypeStructure();
        this.unitaImmobiliari = false;
        this.docUploaded = false;
        this.barCode = "";
        this.contratti = false;
        // Dati aggiuntivi elenco/nuovo elemento
        this.suppliersName = [];
        this.yearsOfStorage = [];
        this.conductorName = [];
        this.nameInterventionArchiving = [];
        this.searchValue = "";
        this.documentTemplateId = "";
        this.documentTemplate = [];
        this.loggedUserAdmin = false;
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    PropertyDetailDocumentInsertDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) {
            _this.loggedUser = res;
            // Get logged user's role data
            var currentRole = _this.loggedUser.userRoles.find(function (obj) {
                return (obj._id.toString() ===
                    _this.authService.loggedUserRequestedRole$.getValue().toString());
            });
            if (typeof currentRole !== 'undefined') {
                _this.loggedUserAdmin =
                    currentRole.role.type === "admin" ||
                        currentRole.role.type === "operator";
            }
        }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        // Only admins/operators can choose between digital/paper documents
        if (this.authService.loggedUserRequestedRoleType$.getValue() === "master"
            || this.authService.loggedUserRequestedRoleType$.getValue() === "collaborator") {
            this.docType = "digital";
        }
        // Get current lang
        this.lang = this.cookieService.get("lang") || this.configService.defaultLang;
        this.key = this.data.key;
        this.condoStructure = this.data.condoStructure;
        this.documentArchive = this.data.documentArchive;
        if (this.documentArchive.suppliersName) {
            this.suppliersName = this.documentArchive.suppliersName;
        }
        if (this.documentArchive.yearsOfStorage) {
            this.yearsOfStorage = this.documentArchive.yearsOfStorage;
        }
        if (this.documentArchive.conductorName) {
            this.conductorName = this.documentArchive.conductorName;
        }
        if (this.documentArchive.nameInterventionArchiving) {
            this.nameInterventionArchiving =
                this.documentArchive.nameInterventionArchiving;
        }
        this.subscriptionType = this.data.subscriptionType;
        this.barCode = this.data.barCode;
        if (!this.key) {
            this.toastrService.error("No key injected");
            return;
        }
        if (!this.condoStructure && this.subscriptionType !== "FREE" && this.subscriptionType !== "FREEBASIC") {
            this.toastrService.error("No structure injected");
            return;
        }
        if (!this.documentArchive) {
            this.toastrService.error("No archive injected");
            return;
        }
        if (!this.barCode) {
            this.toastrService.error("No barCode injected");
            return;
        }
        this.subscriptions.push(this.settingsService.getDocument().subscribe(function (res) {
            if (res.status) {
                if (res.data &&
                    Array.isArray(res.data) &&
                    res.data.length > 0 &&
                    res.data[0].area &&
                    Array.isArray(res.data[0].area)) {
                    _this.documentTemplateId = res.data[0]._id;
                    _this.documentTemplate = res.data[0].area;
                    // this.setVisibleDocsByStructures();
                    _this.getData();
                }
            }
        }, function (err) {
            //
        }));
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    PropertyDetailDocumentInsertDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Init form basing on docType
     *
     * @since 1.0.0
     */
    PropertyDetailDocumentInsertDialogComponent.prototype.onChooseDocType = function (type) {
        var _this = this;
        this.docType = type;
        this.initForm("", "");
        setTimeout(function () {
            if (_this.docType === 'digital'
                && (_this.data.action === 'new' || _this.data.action === 'edit')) {
                _this.watchFileChanges();
            }
        }, 500);
    };
    /**
     * Watch for file-uploader changes, if file was uploaded
     * scroll down on dialog bottom
     *
     * @since 1.0.0
     */
    PropertyDetailDocumentInsertDialogComponent.prototype.watchFileChanges = function () {
        var _this = this;
        if (this.form.controls["documentFile"]) {
            this.subscriptions.push(this.form.controls["documentFile"].valueChanges.subscribe(function (res) {
                // A file was uploaded, scroll down dialog
                if (Array.isArray(res) && res.length) {
                    var dialogWindow = document.getElementsByTagName("mat-dialog-container")[0]; // assuming we can have only one dialog opened
                    if (dialogWindow) {
                        var contentToScroll = dialogWindow.getElementsByClassName("mat-dialog-content");
                        if (contentToScroll[0]) {
                            var bottomHeight = contentToScroll[0].scrollHeight;
                            contentToScroll[0].scrollTo({
                                top: bottomHeight,
                                behavior: "smooth",
                            });
                        }
                    }
                }
            }, function (err) {
                _this.helperService.handleError(err);
            }));
        }
    };
    /**
     * Handle data and form init
     *
     * @since 1.0.0
     */
    PropertyDetailDocumentInsertDialogComponent.prototype.getData = function () {
        var e_1, _a, e_2, _b;
        var _this = this;
        // this.topics = this.documentTypeStructure.getSubDocsArea(this.key);
        if (this.key === 'unitaImmobiliari') {
            this.unitaImmobiliari = true;
        }
        var subscriptionFree = false;
        if (this.subscriptionType === "FREE" || this.subscriptionType === "FREEBASIC") {
            subscriptionFree = true;
        }
        this.topics = this.documentTypeStructure.getSubDocsArea2(this.key, this.documentTemplate, subscriptionFree);
        if (this.topics && this.topics.documents && Array.isArray(this.topics.documents)) {
            // Only Privacy
            if (this.subscriptionType === 'PRIVACY' &&
                !this.loggedUserAdmin) {
                this.topics.documents = this.topics.documents.filter(function (el) { return el.privacy; });
            }
            // Align the list with the search box, empty as the dialog opens: every doc starts visible
            applyDocumentSearch(this.topics.documents, this.searchValue, this.lang);
            this.displayedStructures = [];
            this.displayedStructuresContract = [];
            this.title = this.topics.title.replace("properties.documents.", "");
            if (this.subscriptionType !== "FREE" && this.subscriptionType !== "FREEBASIC") {
                if (this.title === "contratti") {
                    this.contratti = true;
                    var index_1 = -1;
                    var activeStructures_1 = false;
                    var copiedDocuments = JSON.parse(JSON.stringify(this.topics.documents));
                    copiedDocuments.forEach(function (el) {
                        var structure = el.structure;
                        var origin = el.origin;
                        var key = el.key;
                        if (structure && structure !== "") {
                            if (_this.condoStructure[structure].length) {
                                activeStructures_1 = false;
                                _this.condoStructure[structure].forEach(function (item) {
                                    if (typeof item.active !== "undefined" && item.active) {
                                        var name_1 = item.nome;
                                        switch (structure) {
                                            case "dipendenti":
                                                name_1 = item.nome + " " + item.cognome;
                                                break;
                                            case "contatoreGas":
                                                name_1 = item.nome + " - " + item.codicePdr;
                                                break;
                                            case "ascensore":
                                                name_1 = item.nome + " - " + item.numeroMatricola;
                                                break;
                                            case "montauto":
                                                name_1 = item.nome + " - " + item.numeroMatricola;
                                                break;
                                            case "contatoriAcqua":
                                                name_1 = item.nome + " - " + item.codiceUtente;
                                                break;
                                            // case "estintori":
                                            //   name = "Estintori";
                                            //   break;
                                        }
                                        activeStructures_1 = true;
                                        var index_2 = _this.displayedStructuresContract.findIndex(function (structureEl) {
                                            return structureEl.id.toString() === item._id.toString();
                                        });
                                        if (index_2 === -1) {
                                            _this.displayedStructuresContract.push({
                                                id: item._id,
                                                name: name_1,
                                                value: false,
                                                type: structure,
                                                origin: origin
                                            });
                                        }
                                    }
                                });
                                if (!activeStructures_1) {
                                    index_1 = _this.topics.documents.findIndex(function (item) {
                                        return item.key === key;
                                    });
                                    _this.topics.documents.splice(index_1, 1);
                                }
                            }
                            else {
                                index_1 = _this.topics.documents.findIndex(function (item) {
                                    return item.key === key;
                                });
                                _this.topics.documents.splice(index_1, 1);
                                if (structure === "fornituraMt") {
                                    index_1 = _this.topics.documents.findIndex(function (item) {
                                        return item.key === "HA64";
                                    });
                                    _this.topics.documents.splice(index_1, 1);
                                }
                            }
                        }
                    });
                }
                else if (this.unitaImmobiliari) {
                    var structure_1 = 'unitaAbitativaCommerciale';
                    this.condoStructure[structure_1].forEach(function (item) {
                        if (typeof item.active !== "undefined" && item.active) {
                            _this.displayedStructures.push({
                                id: item._id,
                                name: item.nome,
                                value: false,
                                type: structure_1
                            });
                        }
                    });
                }
                else {
                    var _loop_1 = function (docs) {
                        if (!docs.deleted) {
                            var content = docs.content;
                            if (content && Array.isArray(content)) {
                                var index = content.findIndex(function (subDocs) {
                                    return (subDocs.title.replace("properties.documents.", "") === _this.title);
                                });
                                if (index > -1) {
                                    var structure_2 = content[index].structure;
                                    if (structure_2 && structure_2 !== "") {
                                        this_1.condoStructure[structure_2].forEach(function (item) {
                                            if (typeof item.active !== "undefined" && item.active) {
                                                var name_2 = item.nome;
                                                switch (structure_2) {
                                                    case "dipendenti":
                                                        name_2 = item.nome + " " + item.cognome;
                                                        break;
                                                    case "contatoreGas":
                                                        name_2 = item.nome + " - " + item.codicePdr;
                                                        break;
                                                    case "ascensore":
                                                        name_2 = item.nome + " - " + item.numeroMatricola;
                                                        break;
                                                    case "montauto":
                                                        name_2 = item.nome + " - " + item.numeroMatricola;
                                                        break;
                                                    case "contatoriAcqua":
                                                        name_2 = item.nome + " - " + item.codiceUtente;
                                                        break;
                                                    // case "estintori":
                                                    //   name = "Estintori";
                                                    //   break;
                                                }
                                                _this.displayedStructures.push({
                                                    id: item._id,
                                                    name: name_2,
                                                    value: false,
                                                    type: structure_2
                                                });
                                            }
                                        });
                                    }
                                    else {
                                        if (this_1.title === "vvFdefinitivo") {
                                            if (this_1.documentArchive.vvFdefinitivo
                                                && Array.isArray(this_1.documentArchive.vvFdefinitivo)) {
                                                this_1.documentArchive.vvFdefinitivo.forEach(function (item) {
                                                    if (item.structureObjectType !== "") {
                                                        _this.displayedStructures.push({
                                                            id: item.structureObjectId,
                                                            name: item.structureObjectName,
                                                            value: false,
                                                            type: "vvFdefinitivo",
                                                            typeStructure: item.structureObjectType
                                                        });
                                                    }
                                                    else if (item.structureObjectId === "-1") {
                                                        var structure_3 = {
                                                            id: item.structureObjectId,
                                                            name: _this.lang === "it" ? "Edificio uso terziario " + item.structureObjectName : "Tertiary use building " + item.structureObjectName,
                                                            value: false,
                                                            type: "vvFdefinitivo",
                                                            typeStructure: item.structureObjectType,
                                                        };
                                                        _this.displayedStructures.push(structure_3);
                                                    }
                                                });
                                            }
                                        }
                                    }
                                    return "break";
                                }
                            }
                        }
                    };
                    var this_1 = this;
                    try {
                        for (var _c = tslib_1.__values(this.documentTemplate), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var docs = _d.value;
                            var state_1 = _loop_1(docs);
                            if (state_1 === "break")
                                break;
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
            }
            else {
                if (this.title === "contratti") {
                    this.contratti = true;
                    this.selectedStructureFree = "-1";
                }
                else {
                    try {
                        for (var _e = tslib_1.__values(this.documentTemplate), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var docs = _f.value;
                            if (!docs.deleted) {
                                var content = docs.content;
                                if (content && Array.isArray(content)) {
                                    var index = content.findIndex(function (subDocs) {
                                        return (subDocs.title.replace("properties.documents.", "") ===
                                            _this.title && subDocs.structure && subDocs.structure !== "");
                                    });
                                    if (index > -1) {
                                        this.selectedStructureFree = "-1";
                                    }
                                }
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
        }
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    PropertyDetailDocumentInsertDialogComponent.prototype.initForm = function (docKey, schemaType) {
        var _this = this;
        this.fields = [];
        this.model = {};
        if (this.form && this.form.controls) {
            for (var key in this.form.controls) {
                delete this.form.controls[key];
            }
        }
        // create default field to formly
        var defaultFields = [
            {
                className: "col-12",
                type: "textarea",
                key: "contenutoDocumento",
                templateOptions: {
                    label: this.translateService.instant("properties.detail.documentArchive.fields.contenutoDocumento"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.contenutoDocumento"),
                    required: true,
                    minLength: 2,
                    maxLength: 500,
                    rows: 5,
                }
            },
            {
                className: "col-12 col-md-12 col-xl-12",
                type: "input",
                key: "protocollo",
                templateOptions: {
                    readonly: false,
                    label: this.translateService.instant("properties.detail.documentArchive.fields.protocollo"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.protocollo"),
                    required: false,
                    minLength: 0,
                    maxLength: 500,
                },
            },
            {
                className: "col-12 col-md-12 col-xl-12",
                type: "textarea",
                key: "keyword",
                templateOptions: {
                    readonly: false,
                    label: this.translateService.instant("properties.detail.documentArchive.fields.keyword"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.keyword"),
                    required: false,
                    minLength: 0,
                    maxLength: 1000,
                    rows: 3
                },
            }
        ];
        // create fields formly from document key: es AA1
        // const aryfields = this.documentTypeStructure.getFormlyFields(docKey, false);
        var aryfields = this.documentTypeStructure.getFormlyFields2(schemaType, false);
        if (aryfields && aryfields.length) {
            aryfields.forEach(function (item) {
                if (item.templateOptions && item.templateOptions.placeholder) {
                    item.templateOptions.placeholder = _this.translateService.instant(item.templateOptions.placeholder);
                }
                if (item.type === "select") {
                    if (Array.isArray(item.templateOptions.options)) {
                        item.templateOptions.options.forEach(function (subItem) {
                            subItem.label = _this.translateService.instant(subItem.label);
                        });
                    }
                }
                if (item.type === "selectNew") {
                    item.type = "autocomplete";
                    if (item.templateOptions.initialValues) {
                        var options_1 = [];
                        switch (item.templateOptions.initialValues) {
                            case "suppliersName":
                                _this.suppliersName.forEach(function (subItem) {
                                    // options.push({
                                    //   value: subItem,
                                    //   label: subItem,
                                    // });
                                    options_1.push(subItem);
                                });
                                break;
                            case "yearsOfStorage":
                                _this.yearsOfStorage.forEach(function (subItem) {
                                    // options.push({
                                    //   value: subItem,
                                    //   label: subItem,
                                    // });
                                    options_1.push(subItem);
                                });
                                break;
                            case "conductorName":
                                _this.conductorName.forEach(function (subItem) {
                                    // options.push({
                                    //   value: subItem,
                                    //   label: subItem,
                                    // });
                                    options_1.push(subItem);
                                });
                                break;
                            case "nameInterventionArchiving":
                                _this.nameInterventionArchiving.forEach(function (subItem) {
                                    // options.push({
                                    //   value: subItem,
                                    //   label: subItem,
                                    // });
                                    options_1.push(subItem);
                                });
                                break;
                        }
                        item.templateOptions.initialValues = options_1;
                        item.templateOptions.addTagText = _this.translateService.instant(item.templateOptions.addTagText);
                        item.templateOptions.customLabel = _this.translateService.instant(item.templateOptions.customLabel);
                    }
                }
                if (item.type === "autocomplete" ||
                    item.type === "autocomplete-supplier") {
                    item.templateOptions.addTagText = _this.translateService.instant(item.templateOptions.addTagText);
                    item.templateOptions.customLabel = _this.translateService.instant(item.templateOptions.customLabel);
                    if (item.templateOptions.search$ === "suppliersService") {
                        item.templateOptions.search$ = _this.suppliersService.getListV2.bind(_this);
                    }
                }
                else {
                    if (item.templateOptions && item.templateOptions.label) {
                        item.templateOptions.label = _this.translateService.instant(item.templateOptions.label);
                    }
                }
            });
            var fieldGroup = aryfields.concat(defaultFields);
            var itemConfig = [
                {
                    fieldGroupClassName: "row",
                    fieldGroup: fieldGroup
                }
            ];
            this.fields = itemConfig;
            if (this.docType && this.docType === 'digital') {
                this.fields.push({
                    fieldGroupClassName: "row",
                    fieldGroup: [
                        {
                            className: "col-12",
                            type: "file-uploader",
                            key: "documentFile",
                            templateOptions: {
                                required: true,
                                allowedFilesNumber: 200,
                                allowedFilesExtensions: this.configService.allowedDocumentExtensions,
                                customLabel: this.translateService.instant('properties.detail.documentArchive.fields.file'),
                            },
                            // Show file upload only if file is not uploaded yet
                            hideExpression: typeof this.data.itemData !== 'undefined'
                                && this.data.itemData.document
                                && this.data.itemData.document._id !== ''
                        }
                    ]
                });
            }
            else if (this.docType && this.docType === 'paper') {
                // For better fields displaying
                // this.dialogRef.updateSize('60vw');
                this.fields.push({
                    fieldGroupClassName: "row",
                    fieldGroup: [
                        {
                            className: "col-6",
                            type: "input",
                            key: "numFiles",
                            hooks: {
                                onInit: function (field) {
                                    field.formControl.valueChanges
                                        .pipe(tap(function (value) {
                                        if (typeof value === "undefined") {
                                            value = null;
                                        }
                                        if (value > field.templateOptions.max) {
                                            value = field.templateOptions.max;
                                        }
                                        if (_this.model.files) {
                                            _this.model.files.length = value;
                                        }
                                        _this.model = tslib_1.__assign({}, _this.model, { numFiles: value });
                                    }))
                                        .subscribe();
                                }
                            },
                            templateOptions: {
                                type: "number",
                                label: this.translateService.instant('properties.detail.documentArchive.fields.numFiles'),
                                required: false,
                                min: 2,
                                max: 100,
                            },
                            expressionProperties: {
                                // apply expressionProperty for disabled based on formState
                                "templateOptions.disabled": "formState.disabled"
                            },
                        },
                        {
                            className: "docs-radio-group-wrapper col-12",
                            key: "files",
                            type: "repeat",
                            expressionProperties: {
                                // apply expressionProperty for disabled based on formState
                                "templateOptions.disabled": "formState.disabled"
                            },
                            fieldArray: {
                                fieldGroup: [
                                    {
                                        className: "pl-0 col-12 col-md-6",
                                        type: "input",
                                        key: "name",
                                        hooks: {
                                            onInit: function (field) {
                                                var type = field.parent.fieldGroup[1].defaultValue[0]; // take first letter from radio's defaultValue
                                                var name = this.barCode; // barcode value
                                                var index = +field.parent.key + 1; // actual array index plus 1
                                                field.defaultValue = (name + "_" + type + index).toUpperCase();
                                            },
                                        },
                                        templateOptions: {
                                            label: this.translateService.instant('properties.detail.documentArchive.fields.name'),
                                            placeholder: this.translateService.instant('properties.detail.documentArchive.fields.name'),
                                            minLength: 0,
                                            maxLength: 500,
                                            readonly: true,
                                        },
                                    },
                                    {
                                        className: "col-12 col-md-6",
                                        type: "radio",
                                        key: "docType",
                                        defaultValue: "report",
                                        expressionProperties: {
                                            "templateOptions.onChange": function (model, opt, field) {
                                                if (model) {
                                                    var position = +field.parent.key;
                                                    // @todo: da rivedere (segnalato in #105)
                                                    // Return if no changes were made
                                                    // if (
                                                    //   this.previousDocTypes.map(el => el.value).includes(field.formControl.value)
                                                    //   && this.previousDocTypes.map(el => el.position).includes(position)
                                                    // ) {
                                                    //   return;
                                                    // }
                                                    // this.previousDocTypes = [];
                                                    // field.parent.parent.fieldGroup.forEach(el => {
                                                    //   this.previousDocTypes.push({
                                                    //     position,
                                                    //     value: el.formControl.value.docType
                                                    //   });
                                                    // });
                                                    var type = model.docType[0]; // take first letter from radio's actual value
                                                    var name_3 = _this.barCode; // barcode value
                                                    var index = position + 1; // actual array index plus 1;
                                                    // Set new value in model
                                                    model.name = (name_3 + "_" + type + index).toUpperCase();
                                                    // Set new value in field (make it change inside form input)
                                                    field.parent.fieldGroup[0].formControl.setValue(model.name);
                                                }
                                            },
                                        },
                                        templateOptions: {
                                            label: this.translateService.instant('properties.detail.documentArchive.fields.docType'),
                                            options: [
                                                {
                                                    value: "report",
                                                    label: this.translateService.instant('properties.detail.documentArchive.fields.report'),
                                                },
                                                {
                                                    value: "tables",
                                                    label: this.translateService.instant('properties.detail.documentArchive.fields.tables'),
                                                },
                                                {
                                                    value: "calcs",
                                                    label: this.translateService.instant('properties.detail.documentArchive.fields.calcs'),
                                                },
                                                {
                                                    value: "schemas",
                                                    label: this.translateService.instant('properties.detail.documentArchive.fields.schemas'),
                                                },
                                                {
                                                    value: "various",
                                                    label: this.translateService.instant('properties.detail.documentArchive.fields.various'),
                                                }
                                            ],
                                        }
                                    },
                                ]
                            }
                        }
                    ]
                });
            }
            else {
                this.toastrService.error('Error: no docType selected');
            }
            setTimeout(function () {
                _this.watchFileChanges();
            }, 500);
        }
    };
    /**
     * View the structures of select contracts
     *
     * @since 1.0.0
     */
    PropertyDetailDocumentInsertDialogComponent.prototype.viewContractStructures = function () {
        var _this = this;
        var contractStructures = [];
        this.displayedStructures = [];
        this.topics.documents.forEach(function (el) {
            if (el.value) {
                if (el.origin !== "" && el.structure && el.structure !== "") {
                    contractStructures = _this.displayedStructuresContract.filter(function (item) {
                        var index = _this.displayedStructures.findIndex(function (subEl) {
                            return subEl.id === item.id;
                        });
                        if (index === -1) {
                            return item.type === el.structure;
                        }
                    });
                    _this.displayedStructures = _this.displayedStructures.concat(contractStructures);
                }
            }
        });
    };
    /**
     * Handle enabling same docs type
     *
     * @since 1.0.0
     */
    PropertyDetailDocumentInsertDialogComponent.prototype.onSetDoc = function (key, schemaType, checked, title, parentTitle) {
        var e_3, _a;
        var _this = this;
        var titleDoc = '';
        if (this.lang === "it") {
            titleDoc = title.it;
        }
        else {
            titleDoc = title.en;
        }
        var type = this.documentTypeStructure.getDocumentType2(key, this.documentTemplate);
        if (this.topics.title.replace("properties.documents.", "") === "contratti") {
            this.viewContractStructures();
        }
        // see if at least one checkbox is selected...
        var selected = false;
        if (this.topics.documents && Array.isArray(this.topics.documents)) {
            this.topics.documents.forEach(function (el) {
                if (!checked) {
                    if (el.key !== key && el.value) {
                        selected = true;
                    }
                }
                else {
                    selected = true;
                    if (_this.documentTypeStructure.getDocumentType2(el.key, _this.documentTemplate) === type) {
                        el.disabled = false;
                    }
                    else {
                        el.disabled = true;
                    }
                }
            });
        }
        // ...otherwise, enable all checkbox...
        if (!selected) {
            this.topics.documents.forEach(function (el) {
                el.disabled = false;
            });
            // ...and delete/reset form fields
            this.fields = [];
        }
        else {
            // If we're here means we have at least one checkbox selected
            if (type !== this.previousDocType
                || !this.selectedDocs.length) {
                this.previousDocType = type;
                this.initForm(key, schemaType);
            }
        }
        // Handle selectedDocs array
        if (checked) {
            var subDoc_1 = this.title;
            var title_1 = this.topics.title.replace("properties.documents.", "");
            if (title_1 === "contratti") {
                var contractStructures = [];
                var contracts = this.topics.documents.filter(function (el) {
                    return el.key === key;
                });
                if (contracts && Array.isArray(contracts) && contracts[0].origin) {
                    // Questo qui: topic = R o R3 - RM5 - ND3 - LA8 - AD2
                    subDoc_1 = contracts[0].origin;
                    if (subDoc_1 === "impelegenerale-contratti") {
                        contractStructures = this.selectedStructures.filter(function (item) {
                            return item.type === "fornituraBt";
                        });
                    }
                    else if (subDoc_1 === "impeleMediaTensione-contratti") {
                        contractStructures = this.selectedStructures.filter(function (item) {
                            return item.type === "fornituraMt";
                        });
                    }
                    else {
                        var _loop_2 = function (docs) {
                            if (!docs.deleted) {
                                var content = docs.content;
                                if (content && Array.isArray(content)) {
                                    var index = content.findIndex(function (subDocs) {
                                        return (subDocs.title.replace("properties.documents.", "") ===
                                            subDoc_1);
                                    });
                                    if (index > -1) {
                                        var structure_4 = content[index].structure;
                                        contractStructures = this_2.selectedStructures.filter(function (item) {
                                            return item.type === structure_4;
                                        });
                                    }
                                }
                            }
                        };
                        var this_2 = this;
                        try {
                            for (var _b = tslib_1.__values(this.documentTemplate), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var docs = _c.value;
                                _loop_2(docs);
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                    }
                    var doc = {
                        subDoc: subDoc_1,
                        subAreaTitle: "",
                        title: titleDoc,
                        key: key,
                        structureSelected: contractStructures,
                    };
                    this.selectedDocs.push(doc);
                }
                else {
                    var doc = {
                        subDoc: "contratti",
                        subAreaTitle: "",
                        title: titleDoc,
                        key: key,
                        structureSelected: [],
                    };
                    this.selectedDocs.push(doc);
                }
            }
            else if (this.unitaImmobiliari) {
                var doc = {
                    subDoc: parentTitle,
                    subAreaTitle: "",
                    title: titleDoc,
                    key: key,
                    structureSelected: this.selectedStructures,
                };
                this.selectedDocs.push(doc);
            }
            else {
                var doc = {
                    subDoc: subDoc_1,
                    subAreaTitle: "",
                    title: titleDoc,
                    key: key,
                    structureSelected: this.selectedStructures,
                };
                this.selectedDocs.push(doc);
            }
        }
        else {
            var index = this.selectedDocs.map(function (el) { return el.key; }).indexOf(key);
            this.selectedDocs.splice(index, 1);
        }
    };
    /**
     * Check which structures are selected and then enable submit button
     *
     * @since 1.0.0
     */
    PropertyDetailDocumentInsertDialogComponent.prototype.onChangePlant = function (item, checked) {
        var _this = this;
        // Handle selectedStructures array
        if (checked) {
            this.selectedStructures.push(item);
        }
        else {
            var index = this.selectedStructures.map(function (el) { return el.id; }).indexOf(item.id);
            this.selectedStructures.splice(index, 1);
        }
        var title = this.topics.title.replace("properties.documents.", "");
        if (title === "contratti") {
            var contractStructures_1 = [];
            if (Array.isArray(this.selectedDocs)) {
                this.selectedDocs.forEach(function (el) {
                    //   origin: "impelegenerale",
                    if (el.subDoc !== "") {
                        contractStructures_1 = _this.selectedStructures.filter(function (item) {
                            return item.origin === el.subDoc;
                        });
                    }
                    el.structureSelected = contractStructures_1;
                });
            }
        }
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     */
    PropertyDetailDocumentInsertDialogComponent.prototype.onClose = function (data) {
        if (this.data) {
            if (this.data.item) {
                this.data.item.note = this.existingNotes;
            }
        }
        this.dialogRef.close(data);
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    PropertyDetailDocumentInsertDialogComponent.prototype.onFormSubmit = function () {
        var _this = this;
        // Prevent invalid data submit
        if (this.contratti && this.subscriptionType !== "FREE" && this.subscriptionType !== "FREEBASIC") {
            if (!this.selectedDocs.length) {
                this.toastrService.error(this.translateService.instant("common.errors.chooseElementFirst"));
                return;
            }
            if (this.displayedStructures.length && !this.selectedStructures.length) {
                this.toastrService.error(this.translateService.instant("common.errors.chooseStructureFirst"));
                return;
            }
            var errStructure_1 = false;
            this.selectedDocs.forEach(function (item) {
                var e_4, _a, e_5, _b;
                var found = false;
                if (_this.documentTemplate && Array.isArray(_this.documentTemplate)) {
                    try {
                        for (var _c = tslib_1.__values(_this.documentTemplate), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var docs = _d.value;
                            var content = docs.content;
                            if (content && Array.isArray(content)) {
                                try {
                                    for (var content_1 = (e_5 = void 0, tslib_1.__values(content)), content_1_1 = content_1.next(); !content_1_1.done; content_1_1 = content_1.next()) {
                                        var subDocs = content_1_1.value;
                                        var title = subDocs.title.replace("properties.documents.", "");
                                        if (title === item.subDoc && subDocs.structure && subDocs.structure !== "") {
                                            if (!item.structureSelected || !item.structureSelected.length) {
                                                _this.toastrService.error(_this.translateService.instant("common.errors.chooseElementFirst"));
                                                errStructure_1 = true;
                                            }
                                            found = true;
                                        }
                                        if (found) {
                                            break;
                                        }
                                    }
                                }
                                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                                finally {
                                    try {
                                        if (content_1_1 && !content_1_1.done && (_b = content_1.return)) _b.call(content_1);
                                    }
                                    finally { if (e_5) throw e_5.error; }
                                }
                            }
                            if (found) {
                                break;
                            }
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                }
                if (errStructure_1) {
                    return;
                }
            });
            if (errStructure_1) {
                return;
            }
        }
        else {
            if (!this.selectedDocs.length) {
                this.toastrService.error(this.translateService.instant("common.errors.chooseElementFirst"));
                return;
            }
            if (this.displayedStructures.length && !this.selectedStructures.length) {
                this.toastrService.error(this.translateService.instant("common.errors.chooseStructureFirst"));
                return;
            }
        }
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            console.warn("form", this.form);
            this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
            return;
        }
        if (this.contratti) {
            this.selectedDocs.forEach(function (item) {
                switch (item.subDoc) {
                    case "impelegenerale-contratti":
                    case "impeleMediaTensione-contratti":
                        item.subDoc = "contratti";
                        break;
                }
            });
        }
        // Activate submit button loading status
        this.formBtnOptions.active = true;
        var dataToSend = {};
        if (this.form.value) {
            if (this.docType === 'digital') {
                dataToSend = {
                    data: this.form.value,
                    docsSelected: this.selectedDocs,
                    documentFile: this.form.value.documentFile,
                    contratti: this.contratti,
                };
                if (this.selectedStructures.length) {
                    dataToSend = tslib_1.__assign({}, dataToSend, { structureSelected: this.selectedStructures });
                }
                if (this.subscriptionType === "FREE" || this.subscriptionType === "FREEBASIC") {
                    dataToSend = tslib_1.__assign({}, dataToSend, { structureSelected: this.selectedStructureFree });
                }
                this.subscriptions.push(this.documentArchivesService
                    .updateMultiDoc(this.documentArchive._id, dataToSend)
                    .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
                    .subscribe(function (res) {
                    if (res.status) {
                        if (res.data && typeof res.data === "string") {
                            _this.barCode = res.data.toUpperCase();
                            _this.docUploaded = true;
                        }
                        _this.toastrService.success(res.message);
                        // this.dialogRef.close({
                        //   save: "success"
                        // });
                    }
                }, function (err) {
                    _this.helperService.handleFormlyError(_this.form, err);
                }));
            }
            else if (this.docType === 'paper') {
                // First file is not required and name is equal to barcode - 2021-07-10
                if (!this.model.numFiles || !this.model.files) {
                    this.model.numFiles = 1;
                    this.model.files = [{
                            docType: "",
                            name: this.barCode
                        }];
                }
                dataToSend = {
                    data: tslib_1.__assign({}, this.model, { property: this.data.propertyId, code: this.barCode, area: this.data.selectedArea }),
                    docsSelected: this.selectedDocs,
                    documentFile: this.form.value.documentFile,
                };
                if (this.selectedStructures.length) {
                    dataToSend = tslib_1.__assign({}, dataToSend, { structureSelected: this.selectedStructures });
                }
                if (this.subscriptionType === "FREE" || this.subscriptionType === "FREEBASIC") {
                    dataToSend = tslib_1.__assign({}, dataToSend, { structureSelected: this.selectedStructureFree });
                }
                this.subscriptions.push(this.documentArchivesService
                    .updateMultiPaperDoc(this.documentArchive._id, dataToSend)
                    .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.docUploaded = true;
                        _this.toastrService.success(res.message);
                    }
                }, function (err) {
                    _this.helperService.handleError(err);
                    _this.helperService.handleFormlyError(_this.form, err);
                }));
            }
        }
    };
    /**
     * Handle print file qrCode
     *
     * @since 1.0.0
     */
    PropertyDetailDocumentInsertDialogComponent.prototype.onPrint = function (target) {
        var qrCodes = [];
        if (this.model.files && this.model.files.length) {
            // If we're here we have a paper doc
            this.model.files.forEach(function (file) {
                if (file.name) {
                    qrCodes.push(file.name);
                }
            });
        }
        else if (this.model.documentFile && this.model.documentFile.length) {
            // If we're here we have a digital doc
            qrCodes.push(this.barCode);
        }
        else {
            // Paper doc: First file is not required and name is equal to barcode - 2021-07-10
            qrCodes.push(this.barCode);
        }
        if (!qrCodes.length) {
            this.toastrService.error("No qrCodes to inject");
            return;
        }
        var data;
        if (target === "qr") {
            data = {
                target: target,
                qrCodes: qrCodes,
                propertyName: this.data.property.name,
                propertyCity: this.data.property.address.city,
                propertyAddress: this.data.property.address.route + ", " + this.data.property.address.streetNumber,
                area: this.data.selectedArea,
                docs: this.selectedDocs,
            };
        }
        else if (target === "module") {
            data = {
                target: target,
                qrCodes: qrCodes,
                propertyName: this.data.property.name,
                propertyCity: this.data.property.address.city,
                propertyAddress: this.data.property.address.route + ", " + this.data.property.address.streetNumber,
                area: this.data.selectedArea,
                uploadDate: new Date(),
                content: this.model.contenutoDocumento,
                docs: this.selectedDocs,
                structures: this.displayedStructures.length ? this.displayedStructures.filter(function (el) { return el.value; }) : undefined,
            };
        }
        else {
            this.toastrService.error("missing print target");
        }
        // Open dialog
        this.dialog.open(PrintQrDialogComponent, {
            data: data,
            width: "600px"
        });
    };
    /**
     * Handle filter on docs. A doc hidden by the search is unchecked the same way a click
     * does it, so that selectedDocs, the disabled checkboxes and the form follow what is on
     * screen: a hidden doc is never saved
     *
     * @since 1.0.0
     */
    PropertyDetailDocumentInsertDialogComponent.prototype.applyFilter = function (event) {
        var _this = this;
        this.searchValue = event.target.value;
        var uncheckedDocs = applyDocumentSearch(this.topics ? this.topics.documents : undefined, this.searchValue, this.lang);
        uncheckedDocs.forEach(function (el) {
            _this.onSetDoc(el.key, el.schemaType, false, el.translation, el.parentTitle);
        });
    };
    return PropertyDetailDocumentInsertDialogComponent;
}());
export { PropertyDetailDocumentInsertDialogComponent };
